// src/Settings.js — AVS Cloud | Einstellungen
// Komplett neu — kein Re-render Bug, stabile useEffect Dependencies
import BodyScrollLock from './components/BodyScrollLock';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import BillingAddressForm from './components/BillingAddressForm';

const S = {
  page:     { minHeight: '100vh', padding: '2rem clamp(1rem, 4vw, 2.5rem) 5rem' },
  inner:    { maxWidth: '720px', margin: '0 auto' },
  back:     { display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', fontWeight: 600, color: 'var(--muted)', textDecoration: 'none', marginBottom: '2.5rem', cursor: 'pointer', letterSpacing: '0.04em' },
  title:    { fontFamily: 'var(--font-head)', fontSize: 'clamp(1.8rem,4vw,2.5rem)', fontWeight: 900, letterSpacing: '-0.04em', color: 'var(--white)', marginBottom: '0.4rem', lineHeight: 1.1 },
  subtitle: { fontSize: '0.82rem', color: 'var(--muted)', marginBottom: '2.5rem', paddingBottom: '2rem', borderBottom: '1px solid var(--border)' },
  section:      { marginBottom: '2.5rem', paddingBottom: '2.5rem', borderBottom: '1px solid var(--border)' },
  sectionLast:  { marginBottom: '3rem' },
  sectionTitle: { fontSize: '0.95rem', fontWeight: 700, color: 'var(--cyan)', fontFamily: 'var(--font-head)', marginBottom: '1.25rem', letterSpacing: '-0.01em' },
  card:     { background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border)', borderRadius: '10px', padding: '1.25rem 1.5rem' },
  row:      { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.6rem 0', borderBottom: '1px solid rgba(255,255,255,0.04)' },
  rowLast:  { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.6rem 0' },
  rowLabel: { fontSize: '0.82rem', color: 'var(--muted)' },
  rowValue: { fontSize: '0.88rem', color: 'var(--white)', fontWeight: 600 },
  select:   { padding: '0.55rem 0.9rem', background: 'rgba(255,255,255,0.07)', border: '1px solid var(--border)', borderRadius: '6px', color: 'var(--white)', fontSize: '0.85rem', outline: 'none', cursor: 'pointer', fontFamily: 'inherit' },
  btn:      { padding: '0.65rem 1.25rem', background: 'var(--cyan)', border: 'none', borderRadius: '7px', color: '#0a0a0a', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'var(--font-head)', letterSpacing: '0.02em', transition: 'opacity 0.2s', marginTop: '1rem', display: 'inline-block' },
  btnSmall: { padding: '0.45rem 0.85rem', background: 'var(--cyan)', border: 'none', borderRadius: '6px', color: '#0a0a0a', fontWeight: 700, fontSize: '0.78rem', cursor: 'pointer', fontFamily: 'var(--font-head)' },
  input:    { display: 'block', width: '100%', padding: '0.65rem 0.9rem', background: 'rgba(255,255,255,0.05)', border: '1px solid var(--border)', borderRadius: '6px', color: 'var(--white)', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', margin: '0.35rem 0 0.85rem' },
  ok:  { background: 'rgba(74,222,128,0.08)', border: '1px solid rgba(74,222,128,0.25)', borderRadius: '6px', padding: '0.6rem 0.9rem', marginTop: '0.75rem', fontSize: '0.82rem', color: '#4ade80' },
  err: { background: 'rgba(255,80,80,0.08)', border: '1px solid rgba(255,80,80,0.25)', borderRadius: '6px', padding: '0.6rem 0.9rem', marginTop: '0.75rem', fontSize: '0.82rem', color: '#ff8888' },
  sessionRow:   { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', padding: '0.75rem 0', borderBottom: '1px solid rgba(255,255,255,0.04)' },
  sessionBadge: { fontSize: '0.68rem', padding: '0.12rem 0.45rem', borderRadius: '4px', background: 'rgba(0,212,255,0.1)', color: 'var(--cyan)', border: '1px solid rgba(0,212,255,0.25)', marginLeft: '0.5rem', fontWeight: 700 },
  revokeBtn:    { padding: '0.32rem 0.65rem', background: 'transparent', border: '1px solid rgba(255,80,80,0.3)', borderRadius: '5px', color: '#ff8888', fontSize: '0.72rem', cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0, marginTop: '2px' },
  allRevokeBtn: { marginTop: '0.75rem', padding: '0.5rem 1rem', background: 'transparent', border: '1px solid rgba(255,80,80,0.3)', borderRadius: '6px', color: '#ff8888', fontSize: '0.82rem', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 600 },
  progressBg:   { background: 'rgba(255,255,255,0.08)', borderRadius: '4px', height: '8px', overflow: 'hidden', marginTop: '0.6rem' },
  deleteSection: { background: 'rgba(255,50,50,0.04)', border: '1px solid rgba(255,50,50,0.2)', borderRadius: '10px', padding: '1.25rem 1.5rem', marginTop: '0.5rem' },
  deleteTitle:   { fontSize: '0.88rem', fontWeight: 700, color: '#ff8888', marginBottom: '0.5rem' },
  deleteText:    { fontSize: '0.82rem', color: 'var(--muted)', lineHeight: 1.7, marginBottom: '1rem' },
  deleteBtn:     { padding: '0.65rem 1.25rem', background: 'rgba(255,50,50,0.12)', border: '1px solid rgba(255,50,50,0.35)', borderRadius: '7px', color: '#ff8888', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'var(--font-head)' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.78)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem' },
  modal:   { background: '#0d1520', border: '1px solid var(--border)', borderRadius: '14px', padding: '2rem', maxWidth: '440px', width: '100%', margin: 'auto 0', maxHeight: '90vh', overflowY: 'auto' },
  mTitle:  { fontFamily: 'var(--font-head)', fontSize: '1.1rem', fontWeight: 900, color: 'var(--white)', marginBottom: '1rem' },
  mText:   { fontSize: '0.84rem', color: 'var(--muted)', lineHeight: 1.75, marginBottom: '1.25rem' },
  mInput:  { display: 'block', width: '100%', padding: '0.7rem 1rem', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,80,80,0.3)', borderRadius: '6px', color: 'var(--white)', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box', marginBottom: '1rem', fontFamily: 'inherit' },
  mActions:{ display: 'flex', gap: '0.75rem' },
  mCancel: { flex: 1, padding: '0.7rem', background: 'transparent', border: '1px solid var(--border)', borderRadius: '7px', color: 'var(--muted)', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' },
  mDelete: { flex: 1, padding: '0.7rem', background: 'rgba(255,50,50,0.15)', border: '1px solid rgba(255,50,50,0.4)', borderRadius: '7px', color: '#ff8888', fontWeight: 700, cursor: 'pointer', fontFamily: 'var(--font-head)' },
};

function fmtBytes(b) {
  if (!b) return '0 B';
  if (b < 1024) return b + ' B';
  if (b < 1048576) return (b / 1024).toFixed(1) + ' KB';
  if (b < 1073741824) return (b / 1048576).toFixed(1) + ' MB';
  return (b / 1073741824).toFixed(2) + ' GB';
}
function fmtDate(ts) {
  if (!ts) return '—';
  return new Date(ts).toLocaleString('de-DE');
}
function progressFill(pct) {
  return { height: '100%', borderRadius: '4px', width: `${Math.min(100, pct)}%`, background: pct > 90 ? '#ff6b6b' : pct > 70 ? '#fbbf24' : 'var(--cyan)', transition: 'width 0.4s' };
}

export default function Settings({ token, onLogout }) {
  const navigate = useNavigate();
  const tokenRef = useRef(token);
  useEffect(() => { tokenRef.current = token; }, [token]);

  const auth = () => ({ 'Authorization': `Bearer ${tokenRef.current}`, 'Content-Type': 'application/json' });

  const [profile,           setProfile]           = useState(null);
  const [sessions,          setSessions]          = useState([]);
  const [loading,           setLoading]           = useState(true);
  const [theme,             setTheme]             = useState('dark');
  const [viewMode,          setViewMode]          = useState('comfortable');
  const [maxUploads,        setMaxUploads]        = useState(3);
  const [displaySaving,     setDisplaySaving]     = useState(false);
  const [displayMsg,        setDisplayMsg]        = useState('');
  const [showAddressForm,   setShowAddressForm]   = useState(false);
  const [addressMsg,        setAddressMsg]        = useState('');
  const [sessionMsg,        setSessionMsg]        = useState('');
  const [showDeleteModal,   setShowDeleteModal]   = useState(false);
  const [deleteStep,        setDeleteStep]        = useState(1);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');
  const [deleting,          setDeleting]          = useState(false);
  const [deleteError,       setDeleteError]       = useState('');

  // 2FA state
  const [twoFaStatus,    setTwoFaStatus]    = useState(null);  // { enabled, backup_codes_remaining }
  const [twoFaSetup,     setTwoFaSetup]     = useState(null);  // { qr, manual_key, setup_token } — während Setup
  const [twoFaStep,      setTwoFaStep]      = useState(0);     // 0=idle 1=qr 2=verify 3=backup_codes 4=disable
  const [twoFaCode,      setTwoFaCode]      = useState('');
  const [twoFaBackupShown, setTwoFaBackupShown] = useState(null); // array of plain codes
  const [twoFaSaving,    setTwoFaSaving]    = useState(false);
  const [twoFaMsg,       setTwoFaMsg]       = useState('');
  const [showManualKey,  setShowManualKey]  = useState(false);  // Manual TOTP secret masked by default

  // Login-Methoden (Discord-Verknüpfung + Passwort)
  const [linkMsg,   setLinkMsg]   = useState('');
  const [currentPw, setCurrentPw] = useState('');
  const [newPw,     setNewPw]     = useState('');
  const [newPw2,    setNewPw2]    = useState('');
  const [pwSaving,  setPwSaving]  = useState(false);
  const [pwMsg,     setPwMsg]     = useState('');

  // Sessions live nachladen
  const loadSessions = async () => {
    try {
      const r = await fetch('/api/auth/sessions', { headers: auth() });
      if (r.ok) { const d = await r.json(); if (d.success) setSessions(d.sessions || []); }
    } catch {}
  };

  // Einmaliger Load beim Mount — keine authHeaders Dependency
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [pRes, sRes] = await Promise.all([
          fetch('/api/users/profile', { headers: auth() }),
          fetch('/api/auth/sessions', { headers: auth() }),
        ]);
        if (cancelled) return;
        if (pRes.ok) {
          const d = await pRes.json();
          if (d.success && d.user) {
            setProfile(d.user);
            setTheme(d.user.theme || 'dark');
            setViewMode(d.user.view_mode || 'comfortable');
            setMaxUploads(d.user.max_parallel_uploads || 3);
          }
        }
        if (sRes.ok) {
          const d = await sRes.json();
          if (d.success) setSessions(d.sessions || []);
        }
        await load2FaStatus();
      } catch (e) { console.error('Settings load:', e); }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Live-Polling: Sessions alle 20 Sekunden aktualisieren
  useEffect(() => {
    const iv = setInterval(loadSessions, 20000);
    return () => clearInterval(iv);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Backup-Codes nach 5 Minuten automatisch aus dem State löschen
  useEffect(() => {
    if (twoFaStep !== 3) return;
    const timer = setTimeout(() => {
      setTwoFaStep(0);
      setTwoFaBackupShown(null);
    }, 5 * 60 * 1000);
    return () => clearTimeout(timer);
  }, [twoFaStep]); // eslint-disable-line react-hooks/exhaustive-deps

  // Redirect-Parameter von /api/auth/discord/callback (Account-Verknüpfung) auswerten
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const success = params.get('success');
    const error = params.get('error');
    const message = params.get('message');
    if (success === 'discord_linked') {
      setLinkMsg('ok:Discord-Account erfolgreich verknüpft.');
    } else if (error) {
      setLinkMsg('err:' + (message ? decodeURIComponent(message) : 'Verknüpfung fehlgeschlagen.'));
    }
    if (success || error) {
      window.history.replaceState({}, document.title, '/settings');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const saveDisplay = async () => {
    setDisplaySaving(true); setDisplayMsg('');
    try {
      const res = await fetch('/api/users/settings', { method: 'PATCH', headers: auth(), body: JSON.stringify({ theme, view_mode: viewMode, max_parallel_uploads: maxUploads }) });
      const d = await res.json();
      if (d.success) {
        // Theme sofort anwenden
        if (theme === 'auto') {
          const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
          document.documentElement.classList.toggle('dark', prefersDark);
        } else {
          document.documentElement.classList.toggle('dark', theme === 'dark');
        }
        setDisplayMsg('ok:Einstellungen gespeichert.');
      } else {
        setDisplayMsg('err:' + (d.error || 'Fehler.'));
      }
    } catch { setDisplayMsg('err:Netzwerkfehler.'); }
    finally { setDisplaySaving(false); }
  };

  const handleSaveAddress = async (formData) => {
    const res = await fetch('/api/billing/address', { method: 'PUT', headers: auth(), body: JSON.stringify(formData) });
    const d = await res.json();
    if (!res.ok || !d.success) throw new Error(d.error || 'Fehler');
    const pRes = await fetch('/api/users/profile', { headers: auth() });
    if (pRes.ok) { const p = await pRes.json(); if (p.success) setProfile(p.user); }
    setShowAddressForm(false);
    setAddressMsg('Rechnungsadresse gespeichert.');
  };

  const handleSetPassword = async () => {
    setPwMsg('');
    if (newPw.length < 8) return setPwMsg('err:Das Passwort muss mindestens 8 Zeichen lang sein.');
    if (newPw !== newPw2) return setPwMsg('err:Die Passwörter stimmen nicht überein.');
    setPwSaving(true);
    try {
      const res = await fetch('/api/auth/set-password', { method: 'POST', headers: auth(), body: JSON.stringify({ password: newPw }) });
      const d = await res.json();
      if (d.success) {
        setPwMsg('ok:Passwort wurde festgelegt.');
        setNewPw(''); setNewPw2('');
        const pRes = await fetch('/api/users/profile', { headers: auth() });
        if (pRes.ok) { const p = await pRes.json(); if (p.success) setProfile(p.user); }
      } else {
        setPwMsg('err:' + (d.error || 'Fehler.'));
      }
    } catch { setPwMsg('err:Netzwerkfehler.'); }
    finally { setPwSaving(false); }
  };

  const handleChangePassword = async () => {
    setPwMsg('');
    if (!currentPw) return setPwMsg('err:Bitte aktuelles Passwort eingeben.');
    if (newPw.length < 8) return setPwMsg('err:Das neue Passwort muss mindestens 8 Zeichen lang sein.');
    if (newPw !== newPw2) return setPwMsg('err:Die Passwörter stimmen nicht überein.');
    setPwSaving(true);
    try {
      const res = await fetch('/api/auth/change-password', { method: 'POST', headers: auth(), body: JSON.stringify({ current_password: currentPw, new_password: newPw }) });
      const d = await res.json();
      if (d.success) {
        setPwMsg('ok:Passwort wurde geändert.');
        setCurrentPw(''); setNewPw(''); setNewPw2('');
      } else {
        setPwMsg('err:' + (d.error || 'Fehler.'));
      }
    } catch { setPwMsg('err:Netzwerkfehler.'); }
    finally { setPwSaving(false); }
  };

  const revokeSession = async (sess) => {
    // Optimistisch sofort aus Liste entfernen
    setSessions(prev => prev.filter(s => s.id !== sess.id));
    try {
      const res = await fetch(`/api/auth/sessions/${sess.id}`, { method: 'DELETE', headers: auth() });
      const d = await res.json();
      if (d.success) {
        setSessionMsg('Sitzung beendet.');
        // Falls es die eigene Sitzung war → ausloggen
        if (sess.is_current && onLogout) {
          onLogout();
          navigate('/');
        }
      } else {
        // Rollback falls Fehler
        await loadSessions();
        setSessionMsg('Fehler beim Beenden der Sitzung.');
      }
    } catch {
      await loadSessions();
      setSessionMsg('Netzwerkfehler.');
    }
  };

  const revokeAllOthers = async () => {
    try {
      const res = await fetch('/api/auth/sessions', { method: 'DELETE', headers: auth() });
      const d = await res.json();
      if (d.success) {
        await loadSessions();
        setSessionMsg('Alle anderen Sitzungen beendet.');
      }
    } catch { setSessionMsg('Fehler.'); }
  };

  // ── 2FA Helpers ──────────────────────────────────────────────────────────────
  const load2FaStatus = async () => {
    try {
      const r = await fetch('/api/2fa/status', { headers: auth() });
      if (r.ok) { const d = await r.json(); if (d.success) setTwoFaStatus(d); }
    } catch {}
  };

  const start2FaSetup = async () => {
    setTwoFaSaving(true); setTwoFaMsg('');
    try {
      const r = await fetch('/api/2fa/setup', { method: 'POST', headers: auth() });
      const d = await r.json();
      if (!r.ok || !d.success) { setTwoFaMsg('err:' + (d.error || 'Fehler.')); return; }
      setTwoFaSetup(d);
      setTwoFaStep(1);
      setTwoFaCode('');
    } catch { setTwoFaMsg('err:Netzwerkfehler.'); }
    finally { setTwoFaSaving(false); }
  };

  const confirm2FaEnable = async () => {
    if (twoFaCode.length !== 6) return;
    setTwoFaSaving(true); setTwoFaMsg('');
    try {
      const r = await fetch('/api/2fa/enable', {
        method: 'POST', headers: auth(),
        body: JSON.stringify({ setup_token: twoFaSetup.setup_token, code: twoFaCode }),
      });
      const d = await r.json();
      if (!r.ok || !d.success) { setTwoFaMsg('err:' + (d.error || 'Fehler.')); return; }
      setTwoFaBackupShown(d.backup_codes);
      setTwoFaStep(3);
      setShowManualKey(false);
      await load2FaStatus();
    } catch { setTwoFaMsg('err:Netzwerkfehler.'); }
    finally { setTwoFaSaving(false); }
  };

  const confirm2FaDisable = async () => {
    if (!twoFaCode) return;
    setTwoFaSaving(true); setTwoFaMsg('');
    try {
      const r = await fetch('/api/2fa/disable', {
        method: 'POST', headers: auth(),
        body: JSON.stringify({ code: twoFaCode }),
      });
      const d = await r.json();
      if (!r.ok || !d.success) { setTwoFaMsg('err:' + (d.error || 'Fehler.')); return; }
      setTwoFaStep(0); setTwoFaCode(''); setTwoFaSetup(null);
      await load2FaStatus();
      setTwoFaMsg('ok:2FA erfolgreich deaktiviert.');
    } catch { setTwoFaMsg('err:Netzwerkfehler.'); }
    finally { setTwoFaSaving(false); }
  };

  const handleDeleteAccount = async () => {
    if (deleteConfirmText !== 'LÖSCHEN') return;
    setDeleting(true); setDeleteError('');
    try {
      const res = await fetch('/api/users/delete-account', { method: 'POST', headers: auth(), body: JSON.stringify({}) });
      const d = await res.json();
      if (!res.ok || !d.success) { setDeleteError(d.error || 'Fehler.'); return; }
      if (onLogout) onLogout();
      navigate('/');
    } catch { setDeleteError('Netzwerkfehler.'); }
    finally { setDeleting(false); }
  };

  if (loading) return (
    <div style={S.page}><div style={S.inner}>
      <p style={{ color: 'var(--muted)', fontSize: '0.88rem' }}>Laden…</p>
    </div></div>
  );

  const used  = profile?.storage_used  || 0;
  const limit = profile?.storage_limit || 5368709120;
  const pct   = Math.min(100, (used / limit) * 100);
  const hasAbo = limit > 5368709120;

  const billingInitial = profile?.billing_address_set ? {
    billing_firstname: profile.billing_firstname || '',
    billing_lastname:  profile.billing_lastname  || '',
    billing_street:    profile.billing_street    || '',
    billing_zip:       profile.billing_zip       || '',
    billing_city:      profile.billing_city      || '',
    billing_country:   profile.billing_country   || 'DE',
  } : {};

  return (
    <div style={S.page}>
      <div style={S.inner}>
        <a href="/" style={S.back}>← Zurück zur Cloud</a>
        <h1 style={S.title}>Einstellungen</h1>
        <p style={S.subtitle}>Profil, Sicherheit und Account verwalten.</p>

        {/* 1. Profil */}
        <div style={S.section}>
          <h2 style={S.sectionTitle}>1. Profil</h2>
          <div style={S.card}>
            <div style={S.row}><span style={S.rowLabel}>Benutzername</span><span style={S.rowValue}>{profile?.username || '—'}</span></div>
            <div style={S.row}><span style={S.rowLabel}>E-Mail</span><span style={S.rowValue}>{profile?.email || '—'}</span></div>
            <div style={S.row}><span style={S.rowLabel}>Discord-ID</span><span style={{ ...S.rowValue, fontFamily: 'var(--font-mono)', fontSize: '0.78rem' }}>{profile?.discord_id || '—'}</span></div>
            <div style={S.rowLast}><span style={S.rowLabel}>Mitglied seit</span><span style={S.rowValue}>{fmtDate(profile?.created_at)}</span></div>
          </div>
        </div>

        {/* 2. Darstellung */}
        <div style={S.section}>
          <h2 style={S.sectionTitle}>2. Darstellung</h2>
          <div style={S.card}>
            <div style={S.row}>
              <span style={S.rowLabel}>Theme</span>
              <select style={S.select} value={theme} onChange={e => setTheme(e.target.value)}>
                <option value="dark">Dunkel</option>
                <option value="light">Hell</option>
                <option value="auto">System</option>
              </select>
            </div>
            <div style={S.row}>
              <span style={S.rowLabel}>Ansicht</span>
              <select style={S.select} value={viewMode} onChange={e => setViewMode(e.target.value)}>
                <option value="comfortable">Komfortabel</option>
                <option value="compact">Kompakt</option>
              </select>
            </div>
            <div style={S.rowLast}>
              <span style={S.rowLabel}>Max. parallele Uploads</span>
              <select style={S.select} value={maxUploads} onChange={e => setMaxUploads(Number(e.target.value))}>
                {[1,2,3,5,10].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
          </div>
          {displayMsg && <div style={displayMsg.startsWith('ok') ? S.ok : S.err}>{displayMsg.replace(/^(ok|err):/, '')}</div>}
          <button style={{ ...S.btn, opacity: displaySaving ? 0.5 : 1 }} onClick={saveDisplay} disabled={displaySaving}>
            {displaySaving ? 'Speichert…' : 'Einstellungen speichern'}
          </button>
        </div>

        {/* 3. Rechnungsadresse */}
        <div style={S.section}>
          <h2 style={S.sectionTitle}>3. Rechnungsadresse (§ 14 UStG)</h2>
          {!showAddressForm ? (
            <div style={S.card}>
              {profile?.billing_address_set ? (
                <>
                  <div style={S.row}><span style={S.rowLabel}>Name</span><span style={S.rowValue}>{profile.billing_firstname} {profile.billing_lastname}</span></div>
                  <div style={S.row}>
                    <span style={S.rowLabel}>Anschrift</span>
                    <span style={{ ...S.rowValue, textAlign: 'right' }}>
                      {profile.billing_street}<br />{profile.billing_zip} {profile.billing_city}<br />{profile.billing_country}
                    </span>
                  </div>
                  <div style={S.rowLast}>
                    <span />
                    <span style={{ fontSize: '0.72rem', color: 'var(--muted)', opacity: 0.7 }}>Änderung nur durch Administrator</span>
                  </div>
                </>
              ) : (
                <>
                  <p style={{ fontSize: '0.85rem', color: 'var(--muted)', marginBottom: '0.75rem' }}>
                    Noch keine Rechnungsadresse hinterlegt. Für kostenpflichtige Buchungen erforderlich (§ 14 UStG).
                  </p>
                  <button style={{ ...S.btn, marginTop: 0 }} onClick={() => setShowAddressForm(true)}>Adresse hinterlegen</button>
                </>
              )}
            </div>
          ) : (
            <div style={S.card}>
              <BillingAddressForm
                key="billing-form"
                initialData={billingInitial}
                onSave={handleSaveAddress}
                onCancel={() => setShowAddressForm(false)}
                showTitle={false}
              />
            </div>
          )}
          {addressMsg && <div style={S.ok}>{addressMsg}</div>}
        </div>

        {/* 4. Sicherheit */}
        <div style={S.section}>
          <h2 style={S.sectionTitle}>4. Sicherheit & Sitzungen</h2>
          <div style={S.card}>
            <div style={S.row}><span style={S.rowLabel}>Letzter Login</span><span style={S.rowValue}>{fmtDate(profile?.last_login)}</span></div>
            <div style={{ paddingTop: '0.75rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                <p style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--muted)', letterSpacing: '0.08em', textTransform: 'uppercase', margin: 0 }}>
                  Aktive Geräte / Sitzungen
                </p>
                <button onClick={loadSessions} style={{ padding: '0.25rem 0.6rem', background: 'transparent', border: '1px solid var(--border)', borderRadius: '5px', color: 'var(--muted)', fontSize: '0.7rem', cursor: 'pointer', fontFamily: 'inherit' }}>⟳ Aktualisieren</button>
              </div>
              {sessions.length === 0
                ? <p style={{ fontSize: '0.82rem', color: 'var(--muted)' }}>Keine aktiven Sitzungen gefunden.</p>
                : sessions.map(sess => (
                  <div key={sess.id} style={S.sessionRow}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '0.3rem' }}>
                        <span style={{ fontSize: '0.82rem', color: 'var(--white)', fontWeight: 600 }}>{sess.ip_address || 'unbekannte IP'}</span>
                        {sess.is_current && <span style={S.sessionBadge}>● Aktiv</span>}
                      </div>
                      <div style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.32)', marginTop: '3px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '370px' }}>
                        {sess.user_agent ? sess.user_agent.substring(0, 70) + (sess.user_agent.length > 70 ? '…' : '') : '—'}
                      </div>
                      <div style={{ fontSize: '0.68rem', color: 'rgba(255,255,255,0.22)', marginTop: '2px' }}>
                        Angemeldet: {fmtDate(sess.created_at)} · Läuft ab: {fmtDate(sess.expires_at)}
                      </div>
                    </div>
                    <button
                      style={{ ...S.revokeBtn, ...(sess.is_current ? { borderColor: 'rgba(251,191,36,0.4)', color: '#fbbf24' } : {}) }}
                      onClick={() => revokeSession(sess)}
                      title={sess.is_current ? 'Aktuelle Sitzung beenden (Logout)' : 'Gerät abmelden'}
                    >
                      {sess.is_current ? 'Logout' : 'Abmelden'}
                    </button>
                  </div>
                ))
              }
              {sessions.filter(s => !s.is_current).length > 0 && (
                <button style={S.allRevokeBtn} onClick={revokeAllOthers}>Alle anderen Geräte abmelden</button>
              )}
            </div>
          </div>
          {sessionMsg && <div style={S.ok}>{sessionMsg}</div>}

          {/* Login-Methoden */}
          <div style={{ ...S.card, marginTop: '1.25rem' }}>
            <p style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--muted)', letterSpacing: '0.08em', textTransform: 'uppercase', margin: '0 0 0.75rem' }}>
              Login-Methoden
            </p>
            <div style={profile?.has_password ? S.row : S.rowLast}>
              <span style={S.rowLabel}>Discord</span>
              {profile?.discord_id
                ? <span style={{ ...S.rowValue, color: '#4ade80' }}>Verknüpft ✓</span>
                : <a href="/api/auth/discord/link" style={{ ...S.btnSmall, textDecoration: 'none' }}>Mit Discord verknüpfen</a>}
            </div>
            {profile?.has_password && (
              <div style={S.rowLast}>
                <span style={S.rowLabel}>E-Mail-Login</span>
                <span style={{ ...S.rowValue, color: '#4ade80' }}>Passwort gesetzt ✓</span>
              </div>
            )}
          </div>
          {linkMsg && <div style={linkMsg.startsWith('ok:') ? S.ok : S.err}>{linkMsg.replace(/^(ok|err):/, '')}</div>}

          {/* Passwort setzen / ändern */}
          <div style={{ ...S.card, marginTop: '1.25rem' }}>
            <p style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--muted)', letterSpacing: '0.08em', textTransform: 'uppercase', margin: '0 0 0.75rem' }}>
              {profile?.has_password ? 'Passwort ändern' : 'Passwort festlegen'}
            </p>
            {!profile?.has_password && (
              <p style={{ fontSize: '0.8rem', color: 'var(--muted)', margin: '0 0 0.85rem', lineHeight: 1.6 }}>
                Lege ein Passwort fest, um dich zusätzlich zu Discord per E-Mail und Passwort anzumelden.
              </p>
            )}
            {profile?.has_password && (
              <>
                <span style={S.rowLabel}>Aktuelles Passwort</span>
                <input type="password" autoComplete="current-password" value={currentPw}
                  onChange={e => { setCurrentPw(e.target.value); setPwMsg(''); }} style={S.input} />
              </>
            )}
            <span style={S.rowLabel}>Neues Passwort</span>
            <input type="password" autoComplete="new-password" value={newPw}
              onChange={e => { setNewPw(e.target.value); setPwMsg(''); }} style={S.input} />
            <span style={S.rowLabel}>Neues Passwort wiederholen</span>
            <input type="password" autoComplete="new-password" value={newPw2}
              onChange={e => { setNewPw2(e.target.value); setPwMsg(''); }} style={S.input} />
            {pwMsg && <div style={pwMsg.startsWith('ok:') ? S.ok : S.err}>{pwMsg.replace(/^(ok|err):/, '')}</div>}
            <button style={{ ...S.btn, opacity: pwSaving ? 0.5 : 1 }}
              onClick={profile?.has_password ? handleChangePassword : handleSetPassword} disabled={pwSaving}>
              {pwSaving ? 'Speichert…' : (profile?.has_password ? 'Passwort ändern' : 'Passwort festlegen')}
            </button>
          </div>
        </div>

        {/* 5. Zwei-Faktor-Authentifizierung */}
        <div style={S.section}>
          <h2 style={S.sectionTitle}>5. Zwei-Faktor-Authentifizierung (2FA)</h2>
          <div style={S.card}>
            {/* Status row */}
            <div style={S.row}>
              <span style={S.rowLabel}>Status</span>
              <span style={{ ...S.rowValue, color: twoFaStatus?.enabled ? '#4ade80' : 'var(--muted)' }}>
                {twoFaStatus?.enabled ? '✓ Aktiviert' : 'Deaktiviert'}
              </span>
            </div>
            {twoFaStatus?.enabled && (
              <div style={S.rowLast}>
                <span style={S.rowLabel}>Backup-Codes verbleibend</span>
                <span style={{ ...S.rowValue, color: (twoFaStatus.backup_codes_remaining || 0) < 3 ? '#fb923c' : 'var(--white)' }}>
                  {twoFaStatus.backup_codes_remaining ?? '—'}
                </span>
              </div>
            )}
          </div>

          {/* ── Activate flow ───────────────────────────────────── */}
          {!twoFaStatus?.enabled && twoFaStep === 0 && (
            <button style={{ ...S.btn, marginTop: '1rem', background: 'var(--cyan)', color: '#0a0a0a', opacity: twoFaSaving ? 0.6 : 1 }}
              onClick={start2FaSetup} disabled={twoFaSaving}>
              {twoFaSaving ? 'Lädt…' : '2FA aktivieren'}
            </button>
          )}

          {/* Step 1: QR + Manual key */}
          {twoFaStep === 1 && twoFaSetup && (
            <div style={{ marginTop: '1.25rem' }}>
              <p style={{ fontSize: '0.82rem', color: 'var(--muted)', marginBottom: '1rem', lineHeight: 1.6 }}>
                Scanne den QR-Code mit deiner Authenticator-App (z.B. Google Authenticator oder Authy),
                oder gib den Schlüssel manuell ein. Bestätige danach mit einem einmaligen Code.
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
                <img src={twoFaSetup.qr_code} alt="2FA QR-Code"
                  style={{ width: 180, height: 180, borderRadius: 8, background: '#fff', padding: 4 }} />
              </div>
              <div style={S.card}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.35rem' }}>
                  <span style={S.rowLabel}>Manueller Schlüssel</span>
                  <button
                    onClick={() => setShowManualKey(v => !v)}
                    style={{ background: 'none', border: '1px solid var(--border)', borderRadius: '5px', color: 'var(--muted)', fontSize: '0.68rem', padding: '0.2rem 0.5rem', cursor: 'pointer', fontFamily: 'inherit' }}
                  >
                    {showManualKey ? 'Verbergen' : 'Anzeigen'}
                  </button>
                </div>
                <div style={{ fontFamily: 'monospace', fontSize: '0.9rem', color: 'var(--cyan)', letterSpacing: '0.12em', wordBreak: 'break-all', padding: '0.35rem 0', userSelect: showManualKey ? 'text' : 'none' }}>
                  {showManualKey
                    ? (twoFaSetup.manual_key?.match(/.{1,4}/g)?.join(' ') || twoFaSetup.manual_key)
                    : '•••• •••• •••• •••• •••• •••• •••• ••••'}
                </div>
              </div>
              <p style={{ fontSize: '0.78rem', color: 'var(--muted)', margin: '0.75rem 0 0.5rem' }}>Code aus der App eingeben:</p>
              <input
                type="text" inputMode="numeric" maxLength={6} placeholder="000000"
                value={twoFaCode}
                onChange={e => { setTwoFaCode(e.target.value.replace(/\D/g, '').slice(0, 6)); setTwoFaMsg(''); }}
                style={{ display: 'block', width: '100%', padding: '0.75rem 1rem', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(0,212,255,0.3)', borderRadius: '8px', color: '#fff', fontSize: '1.3rem', letterSpacing: '0.25em', outline: 'none', boxSizing: 'border-box', textAlign: 'center', fontFamily: 'monospace', marginBottom: '0.75rem' }}
              />
              <button
                style={{ ...S.btn, opacity: (twoFaSaving || twoFaCode.length !== 6) ? 0.5 : 1 }}
                onClick={confirm2FaEnable} disabled={twoFaSaving || twoFaCode.length !== 6}>
                {twoFaSaving ? 'Prüfe…' : 'Bestätigen & 2FA aktivieren'}
              </button>
              <button onClick={() => { setTwoFaStep(0); setTwoFaSetup(null); setTwoFaCode(''); setTwoFaMsg(''); setShowManualKey(false); }}
                style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: '0.8rem', cursor: 'pointer', fontFamily: 'inherit', display: 'block', margin: '0 auto' }}>
                Abbrechen
              </button>
            </div>
          )}

          {/* Step 3: Backup codes display (shown once after activation) */}
          {twoFaStep === 3 && twoFaBackupShown && (
            <div style={{ marginTop: '1.25rem' }}>
              <div style={{ background: 'rgba(74,222,128,0.07)', border: '1px solid rgba(74,222,128,0.25)', borderRadius: '8px', padding: '1rem 1.25rem', marginBottom: '1rem' }}>
                <p style={{ fontSize: '0.9rem', fontWeight: 700, color: '#4ade80', marginBottom: '0.5rem' }}>✓ 2FA erfolgreich aktiviert!</p>
                <p style={{ fontSize: '0.78rem', color: 'var(--muted)', lineHeight: 1.6 }}>
                  Bewahre diese 8 Backup-Codes sicher auf. Jeder Code kann nur einmal verwendet werden.
                  Falls du keinen Zugang zu deiner Authenticator-App hast, kannst du dich damit einloggen.
                </p>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', marginBottom: '1rem' }}>
                {twoFaBackupShown.map((c, i) => (
                  <div key={i} style={{ fontFamily: 'monospace', fontSize: '0.88rem', background: 'rgba(255,255,255,0.04)', border: '1px solid var(--border)', borderRadius: '6px', padding: '0.5rem 0.75rem', color: '#fff', letterSpacing: '0.08em', textAlign: 'center' }}>
                    {c}
                  </div>
                ))}
              </div>
              <button style={S.btn} onClick={() => { setTwoFaStep(0); setTwoFaBackupShown(null); }}>
                Codes gespeichert — Fertig
              </button>
            </div>
          )}

          {/* Disable flow */}
          {twoFaStatus?.enabled && twoFaStep === 0 && (
            <div style={{ marginTop: '1rem' }}>
              <button
                style={{ ...S.btn, background: 'rgba(255,80,80,0.12)', border: '1px solid rgba(255,80,80,0.3)', color: '#ff8888', opacity: twoFaSaving ? 0.6 : 1 }}
                onClick={() => { setTwoFaStep(2); setTwoFaCode(''); setTwoFaMsg(''); }}
                disabled={twoFaSaving}>
                2FA deaktivieren
              </button>
            </div>
          )}
          {twoFaStep === 2 && (
            <div style={{ marginTop: '1.25rem' }}>
              <p style={{ fontSize: '0.82rem', color: 'var(--muted)', marginBottom: '0.75rem' }}>
                Gib deinen aktuellen Authenticator-Code (oder einen Backup-Code) ein, um 2FA zu deaktivieren:
              </p>
              <input
                type="text" placeholder="000000 oder XXXXX-XXXXX" maxLength={11}
                value={twoFaCode}
                onChange={e => { setTwoFaCode(e.target.value.toUpperCase().trim()); setTwoFaMsg(''); }}
                style={{ display: 'block', width: '100%', padding: '0.75rem 1rem', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,80,80,0.3)', borderRadius: '8px', color: '#fff', fontSize: '1rem', letterSpacing: '0.12em', outline: 'none', boxSizing: 'border-box', fontFamily: 'monospace', marginBottom: '0.75rem' }}
              />
              <button
                style={{ ...S.btn, background: 'rgba(255,80,80,0.15)', border: '1px solid rgba(255,80,80,0.35)', color: '#ff8888', opacity: (twoFaSaving || !twoFaCode) ? 0.5 : 1 }}
                onClick={confirm2FaDisable} disabled={twoFaSaving || !twoFaCode}>
                {twoFaSaving ? 'Prüfe…' : '2FA deaktivieren'}
              </button>
              <button onClick={() => { setTwoFaStep(0); setTwoFaCode(''); setTwoFaMsg(''); }}
                style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: '0.8rem', cursor: 'pointer', fontFamily: 'inherit', display: 'block', margin: '0.5rem auto 0' }}>
                Abbrechen
              </button>
            </div>
          )}

          {/* Status messages */}
          {twoFaMsg && (
            <div style={twoFaMsg.startsWith('ok:')
              ? { ...S.ok, marginTop: '0.75rem' }
              : { background: 'rgba(255,80,80,0.08)', border: '1px solid rgba(255,80,80,0.25)', borderRadius: '6px', padding: '0.6rem 0.9rem', marginTop: '0.75rem', fontSize: '0.82rem', color: '#ff8888' }}>
              {twoFaMsg.replace(/^(ok|err):/, '')}
            </div>
          )}
        </div>

        {/* 6. Speicher */}
        <div style={S.section}>
          <h2 style={S.sectionTitle}>6. Speicher & Abonnement</h2>
          <div style={S.card}>
            <div style={S.row}>
              <span style={S.rowLabel}>Belegt</span>
              <span style={S.rowValue}>{fmtBytes(used)} / {fmtBytes(limit)} ({pct.toFixed(1)} %)</span>
            </div>
            <div style={S.progressBg}><div style={progressFill(pct)} /></div>
            <div style={{ ...S.rowLast, marginTop: '1rem' }}>
              <span style={S.rowLabel}>Aktueller Plan</span>
              <span style={S.rowValue}>{hasAbo ? 'Kostenpflichtig' : '5 GB Gratis'}</span>
            </div>
          </div>
          <a href="/billing" style={{ ...S.btn, textDecoration: 'none', fontSize: '0.85rem' }}>Speicher verwalten →</a>
        </div>

        {/* 7. Account löschen */}
        <div style={S.sectionLast}>
          <h2 style={S.sectionTitle}>7. Account löschen (DSGVO Art. 17)</h2>
          <div style={S.deleteSection}>
            <p style={S.deleteTitle}>⚠️ Account unwiderruflich löschen</p>
            <p style={S.deleteText}>
              Diese Aktion kann nicht rückgängig gemacht werden. Alle Dateien, Share-Links und Kontodaten
              werden sofort gelöscht. Rechnungen bleiben anonymisiert 10 Jahre gespeichert (§ 147 AO).
            </p>
            <button style={S.deleteBtn} onClick={() => { setShowDeleteModal(true); setDeleteStep(1); setDeleteConfirmText(''); setDeleteError(''); }}>
              Account löschen
            </button>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      {showDeleteModal && (
        <div style={S.overlay} onClick={() => setShowDeleteModal(false)}>
          <div style={S.modal} onClick={e => e.stopPropagation()}>
            {deleteStep === 1 && (
              <>
                <p style={S.mTitle}>Account löschen — Schritt 1 von 2</p>
                <div style={S.mText}>
                  <p><strong style={{ color: '#ff8888' }}>Folgendes wird SOFORT gelöscht:</strong></p>
                  <ul style={{ paddingLeft: '1.2rem', lineHeight: 2, margin: '0.5rem 0 0.75rem' }}>
                    <li>Alle hochgeladenen Dateien</li><li>Alle Share-Links</li><li>Dein Nutzerkonto & alle Sitzungen</li>
                  </ul>
                  <p><strong style={{ color: 'var(--white)' }}>Was bleibt:</strong> Rechnungen werden anonymisiert und 10 Jahre aufbewahrt (§ 147 AO).</p>
                  {hasAbo && <p style={{ marginTop: '0.75rem', color: '#fbbf24' }}><strong>Abo:</strong> Wird sofort gekündigt. Keine weiteren Abbuchungen.</p>}
                </div>
                <div style={S.mActions}>
                  <button style={S.mCancel} onClick={() => setShowDeleteModal(false)}>Abbrechen</button>
                  <button style={S.mDelete} onClick={() => setDeleteStep(2)}>Weiter →</button>
                </div>
              </>
            )}
            {deleteStep === 2 && (
              <>
                <p style={S.mTitle}>Account löschen — Schritt 2 von 2</p>
                <p style={S.mText}>Tippe <strong style={{ color: '#ff8888', fontFamily: 'var(--font-mono)' }}>LÖSCHEN</strong> zur endgültigen Bestätigung:</p>
                <input type="text" style={S.mInput} placeholder="LÖSCHEN" value={deleteConfirmText} onChange={e => setDeleteConfirmText(e.target.value)} autoFocus />
                {deleteError && <div style={{ ...S.err, marginBottom: '1rem' }}>{deleteError}</div>}
                <div style={S.mActions}>
                  <button style={S.mCancel} onClick={() => setShowDeleteModal(false)}>Abbrechen</button>
                  <button
                    style={{ ...S.mDelete, opacity: deleteConfirmText === 'LÖSCHEN' && !deleting ? 1 : 0.35, cursor: deleteConfirmText === 'LÖSCHEN' && !deleting ? 'pointer' : 'not-allowed' }}
                    onClick={handleDeleteAccount}
                    disabled={deleteConfirmText !== 'LÖSCHEN' || deleting}
                  >
                    {deleting ? 'Löscht…' : 'Account endgültig löschen'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
